export const PROJECT_AVOD_ACTIVATE = 'PROJECT_AVOD_ACTIVATE';
export const PROJECT_AVOD_DEACTIVATE = 'PROJECT_AVOD_DEACTIVATE';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/actions/avod.ts